module.exports = __webpack_public_path__ + "img/twitterIcon-dark.4a3ee63f.svg";